import React from 'react';
// import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Col, Container, Row } from 'react-bootstrap';

import { SAnswer } from './styles';

// eslint-disable-next-line react/prop-types
const FaqBlock = ({ faqTableName }) => {
  const allFaqs = useStaticQuery(graphql`
    query {
      allAirtable(
        filter: {
          table: {
            in: [
              "FAQ - Landlord"
              "FAQ - General"
              "FAQ - Tenant"
              "FAQ - Stays"
            ]
          }
        }
      ) {
        nodes {
          data {
            Question
            Answer {
              childMarkdownRemark {
                html
              }
            }
          }
          table
        }
      }
    }
  `);

  const finalFaqs = allFaqs.allAirtable.nodes.filter(
    f => f.table === faqTableName,
  );

  return (
    <Container>
      <Row>
        <Col>
          {finalFaqs.map((faq, i) => (
            <div key={i} className={'mt-5'}>
              <h6>{faq.data.Question}</h6>
              <SAnswer
                dangerouslySetInnerHTML={{
                  __html:
                    faq.data.Answer && faq.data.Answer.childMarkdownRemark.html,
                }}
              />
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default FaqBlock;
